/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

